import { render } from "./tabmenuedition.vue?vue&type=template&id=356cd6aa"
import script from "./tabmenuedition.vue?vue&type=script&lang=ts"
export * from "./tabmenuedition.vue?vue&type=script&lang=ts"
script.render = render

export default script